import { Form, Formik } from 'formik'
import React from 'react'
import { required } from '../utils/validators'
import { positions } from '../utils/position'
import Input from './common/Input'
import Button from './common/Button'
import MultiSelect from './common/MultiSelect'
import Select from './common/Select'
import { useLoad } from '../hooks/request'
import { BRANCH_LIST } from '../urls'

export default function EmployeeForm({ onSubmit, onCancel, loading, initialValues }) {
    const options = Object.entries(positions).map(([value, label]) => ({ value, label }))
    const branch = useLoad({ url: BRANCH_LIST })
    return (
        <Formik initialValues={{
            name: '',
            phoneNumber: '',
            birthday: '',
            company: '',
            salary: 0,
            academyShare: 0,
            sellerShare: 0,
            positions: [],
            ...initialValues,
        }} onSubmit={onSubmit}>
            {({ values }) => (
                <Form>
                    <MultiSelect
                        validate={required}
                        label="Должность"
                        name="positions"
                        placeholder="Введите должности сотрудника"
                        options={options} />

                    <Input
                        label="Имя"
                        name="name"
                        disabled={loading}
                        validate={required}
                        placeholder="Введите имя сотрудника" />

                    <Input
                        label="Номер телефона"
                        name="phoneNumber"
                        validate={required}
                        placeholder="Введите номер телефона" />

                    <Select
                        empty
                        name="company"
                        label="Филиал"
                        loading={branch.loading}
                        options={branch.response ? branch.response : []}
                        help="Выберите филиал"
                        validate={required} />

                    <Input
                        name="birthday"
                        type="date"
                        label="День рождения"
                        disabled={loading}
                        validate={required}
                        placeholder="Введите день рождение сотрудника" />

                    {/*                    {find(values.positions, { value: 'teacher' }) ? (
                        <Input
                            name="academyShare"
                            type="number"
                            label="Доля учителя"
                            disabled={loading}
                            validate={validator(required, max(100), min(0))}
                            placeholder="Введите долю учителя" />
                    ) : null}

                    <Input
                        name="sellerShare"
                        label="Доля от продаж"
                        type="number"
                        disabled={loading}
                        validate={validator(required, max(100), min(0))}
                        placeholder="Введите долю продавца" />

                    <Input
                        name="salary"
                        label="Фиксированная зарплата"
                        type="number"
                        disabled={loading}
                        validate={validator(required, min(0))}
                        placeholder="Введите зарплату сотрудника" /> */}

                    <Button
                        loading={loading}
                        text="Сохранить"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" /> &nbsp;

                    <Button
                        onClick={onCancel}
                        icon="ion-md-close"
                        text="Отмена"
                        className="is-danger" />
                </Form>
            )}
        </Formik>
    )
}
